import Tips from 'components/Tips'
import NavBar from 'components/NavBar'
import Loading from 'components/loading'
import MidWare from 'components/MidWare'
import Refresh from 'components/refresh'
import TipsAuto from 'components/TipsAuto'
import SelectPaper from 'components/SelectPaper'
import { GlobalStore } from 'store/globalStore'

export default {
	data () {
		return {
			midware: false,
			icon: '',
			midFont: '',
			loading: false,
			tips: false,
			tipsauto: false,
			tipsTwoShow: false,
			editStatus: false,
			isTips: false,
			isReturn: false,
			msg: [],
			btnNum: 1,
			imgsrc: '',
			serverId: '',
			tipsFont: '',
			show: true,
			cls: '',
			font: '',
			sec: 1500,
			fileLogicalName: '',
			navbarTitle: '新增证照',
			btnFont: '保存新增',
			paperFont: '请选择证件类型',
			elseTipsFont: '当前证照尚未保存',
			elseBtnFont: ['保存并返回', '放弃并返回', '取消'],
			paperId: '',
			paperName: '',
			paperOrgan: '',
			startDate: '',
			endDate: '',
			queryData: this.$route.query,
			store: GlobalStore
		}
	},
	components: {
		'navbar': NavBar,
		'loading': Loading,
		'tips': Tips,
		'tips-auto': TipsAuto,
		'mid-ware': MidWare,
		'refresh': Refresh,
		'select-paper': SelectPaper
	},
	beforeRouteLeave (to, from, next) {
		if (this.$refs.typeShow.show) {
			next(false)
			this.$refs.typeShow.show = false
			return
		}
		if (this.isTips) {
			next(false)
			this.tipsTwoShow = true
			return
		} else {
			next()
		}
	},
	created () {
		this.fontStatusJudge()
		this.getWechatTicket()
	},
	methods: {
		getWechatTicket () {
			var href = ''
			var device = navigator.userAgent.toLowerCase()
			if (/iphone|ipad|ipod/.test(device)) {
				href = window.location.href.split('?')[0]
			} else if (/android/.test(device)) {
				href = window.location.href
			}
			var url = {
				url: href
			}
			this.$http.post('/cldEdi/api/apiTicket', url).then((response) => {
				var data = response.body
				if (!data.result) {
					this.autoTips(data.message)
				} else {
					this.setWechatConfig(data.data)
				}
			}, (response) => {
				window.console.log('get ticket errpr')
			})
		},
		setWechatConfig (data) {
			// var self = this
			var configInfo = data
			window.wx.config({
				debug: false,
				appId: configInfo.appId,
				timestamp: configInfo.timestamp,
				nonceStr: configInfo.nonceStr,
				signature: configInfo.signature,
				jsApiList: ['scanQRCode', 'chooseImage', 'previewImage', 'uploadImage', 'downloadImage'],
				openTagList: [
					'wx-open-launch-weapp'
				]
			})
			window.wx.error((res) => {
				window.console.log('配置错误:' + res)
			})
		},

		// {{{ showAttachView
		showAttachView () {
			// 附件上传预处理逻辑写这儿
			// ...
			// 触发附件上传逻辑
			this.$refs.attachFile.click()
		},
		// }}}
		// {{{ checkAttachUpload
		checkAttachUpload () {
			var files = this.$refs.attachFile.files
			if (!files.length) {
				this.tipsAutoIco = 'tips-auto-remind-icon'
				this.autoTips('请选择要上传的证照')
				return false
			}
			var attach = this.$refs.attachFile.files[0]
			if (attach.size > 10 * 1024 * 1024) {
				this.tipsAutoIco = 'tips-auto-remind-icon'
				this.autoTips('文件大小不能超过10MB')
				return false
			}
			return true
		},
		// }}}
		// 本地上传
		doAttachUpload (id) {
			if (!id && !this.checkAttachUpload()) {
				return
			}
			this.loading = true
			var method = id ? 'update' : 'upload';
			var filter = new window.FormData()
			var file = this.$refs.attachFile.files[0]
			if (id) {
				filter.append('id', id)
			}
			filter.append('file', file)
			filter.append('name', this.paperName)
			filter.append('certTypeId', this.paperId)
			filter.append('certTypeName', this.paperFont)
			filter.append('issuingAuthority', this.paperOrgan)
			filter.append('beginDate', this.startDate + ' 00:00:00')
			filter.append('endDate', this.endDate + ' 00:00:00')
			// filter.append('fileLogicalName', this.fileLogicalName)
			var meta = {headers: {'Content-Type': 'multipart/form-data'}};
			this.$http.post(`/cldEdi/sysCert/certificates/${method}`, filter, meta).then(res => {
				var res = res.body
				if (!res.result) {
					this.tipsAutoIco = 'tips-auto-wrong-icon'
					this.autoTips(res.message || '操作附件失败')
				} else {
					this.isTips = false
					this.tipsAutoIco = 'tips-auto-right-icon'
					this.autoTips(res.message || '操作附件成功')
					window.setTimeout(() => {
						this.$router.go(-1)
					}, this.sec)
				}
			}, res => {
				this.$refs.attachFile.value = ''
				this.tipsAutoIco = 'tips-auto-network-icon'
				this.autoTips('请求失败，稍后请重试！')
			}).finally(() => {
				this.loading = false
			})
		},
		// }}}
		// {{{ readFile
		readFile (file, func) {
			var reader = new FileReader();
			reader.onload = func;
			reader.readAsDataURL(file);
		},
		// }}}
		// {{{ preview
		preview (e) {
			var file = e.target.files[0];
			if (file.type.indexOf('image') != 0) {
				return
			}
			this.readFile(file, e => {
				this.imgsrc = e.target.result
			})
		},
		// }}}

		uploadFile () {
			var self = this
			window.wx.ready(() => {
				window.wx.chooseImage({
					count: 1,
					sizeType: ['original', 'compressed'],
					sourceType: ['album', 'camera'],
					success: function (res) {
						var localIds = res.localIds
						self.uploadPost(localIds[0])
					}
				})
			})
		},
		uploadPost (id) {
			var self = this
			window.wx.uploadImage({
				localId: id,
				isShowProgressTips: 1,
				success: function (res) {
					var serverId = res.serverId
					self.serverId = serverId
					self.fileLogicalName = serverId
					self.showImg(id)
				}
			})
		},
		showImg (id) {
			var self = this
			var device = navigator.userAgent.toLowerCase()
			if (/android/.test(device)) {
				self.imgsrc = id
			}
			if (/iphone|ipad|ipod/.test(device)) {
				window.wx.getLocalImgData({
					localId: id,
					success: function (res) {
						var localData = res.localData
						self.imgsrc = localData
					}
				})
			}
		},
		fontStatusJudge () {
			var status = this.queryData.status
			if (status === 'add') {
				this.navbarTitle = '新增证照'
				this.btnFont = '保存新增'
				this.elseTipsFont = '当前证照尚未保存'
			}
			if (status === 'edit') {
				this.navbarTitle = '查看证照'
				this.btnFont = '保存修改'
				this.elseTipsFont = '当前证照已修改，是否保存？'
				this.getPaperDetail()
			}
		},
		selectPaper (val) {
			this.$refs.typeShow.open(val)
		},
		autoTips (msg) {
			var self = this
			self.tipsauto = true
			self.tipsFont = msg
			setTimeout(() => {
				self.tipsauto = false
			}, self.sec)
		},
		saveJudge () {
			// 去除两边空格处理
			this.paperName = this.paperName.replace(/^\s+|\s+$/g, '')
			this.paperOrgan = this.paperOrgan.replace(/^\s+|\s+$/g, '')
			// 保存之前先进行数据校验，校验通过后再进行数据提交
			if (this.paperId === '') {
				this.autoTips('请选择证件类型')
				return false
			}
			if (this.paperName === '') {
				this.autoTips('请填写证件名称')
				return false
			}
			if (this.paperOrgan === '') {
				this.autoTips('请填写发证机关')
				return false
			}
			if (this.startDate === '') {
				this.autoTips('请选择生效日期')
				return false
			}
			if (this.endDate === '') {
				this.autoTips('请选择失效日期')
				return false
			}
			if (this.endDate < this.startDate) {
				this.autoTips('失效日期不能小于生效日期')
				return false
			}
			if (this.queryData.status === 'add') {
				this.doAttachUpload()
				return
			}
			if (this.queryData.status === 'edit') {
				this.doAttachUpload(this.queryData.uid)
				return
			}
		},
		getPaperDetail () {
			// 如果是编辑状态，需要根据uid参数查询明细,将值赋值给绑定的数据模型
			var uid = this.queryData.uid
			var data = {
				id: uid
			}
			// 对接编辑状态下查询明细的接口
			this.loading = true
			this.$http.post('/cldEdi/sysCert/getSysCertById', data).then((response) => {
				this.loading = false
				var data = response.body
				if (data.result) {
					// 赋值函数
					this.setValue(data.data)
				} else {
					this.tipsAuto(data.message)
				}
				// window.console.log(response.body)
			}, (response) => {
				this.loading = false
				this.tipsAuto('服务中断，稍后请重试！')
				return
			})
		},
		setValue (data) {
			// 在编辑状态下，为对应字段赋值
			this.paperId = data.certTypeId
			this.paperFont = data.certTypeName
			this.paperName = data.name
			this.paperOrgan = data.issuingAuthority
			this.startDate = this.dateCut(data.beginDate)
			this.endDate = this.dateCut(data.endDate)
			this.imgsrc = data.fileRoot + data.filePhysicalName
			this.fileLogicalName = data.fileLogicalName
		},
		dateCut (val) {
			var arr = val.split(' ')
			return arr[0]
		},
		saveReturn () {
			this.tipsTwoShow = false
			this.isReturn = true
			this.saveJudge()
		},
		returnPrev () {
			var self = this
			setTimeout(() => {
				this.$router.replace({path: '/paper-manager'})
			}, self.sec)
		},
		getSearchCondition (msg) {
			this.paperId = msg.id
			this.paperFont = msg.name
		},
		quitRuturn () {
			this.isTips = false
			// this.editStatus = false
			this.tipsTwoShow = false
			this.$router.replace({path: '/paper-manager'})
		},
		hideRuturnConfirm () {
			this.isTips = false
			var route = this.$route
			var path = route.path
			var query = route.query
			this.tipsTwoShow = false
			this.skipRoute = true
			this.$router.replace({path: '/paper-manager'})
			this.$router.push({
				path: path,
				query: query
			})
			this.skipRoute = false
			this.isTips = true
		},

		// 该方法已停用 @ 20200527
		editSaveDetail () {
			// this.loading = true
			// var obj = {
			//  id: this.queryData.uid,
			//  certTypeId: this.paperId,
			//  certTypeName: this.paperFont,
			//  name: this.paperName,
			//  issuingAuthority: this.paperOrgan,
			//  beginDate: this.startDate + ' 00:00:00',
			//  endDate: this.endDate + ' 00:00:00',
			//  fileLogicalName: this.fileLogicalName
			// }
			// this.$http.post('/cldEdi/sysCert/updateSysCert', obj).then((response) => {
			//  this.loading = false
			//  var data = response.body
			//  if (data.result) {
			//   this.isTips = false
			//   this.autoTips('修改成功')
			//   this.returnPrev()
			//   [> if (this.isReturn) {
			//   } */
			//  } else {
			//   this.autoTips(data.message)
			//   return
			//  }
			// }, (response) => {
			//  this.loading = false
			//  this.autoTips('服务中断，稍后请重试！')
			//  return
			// })
		},
		// 该方法已停用 @ 20200527
		addSaveDetail () {
			// var self = this
			// this.loading = true
			// var obj = {
			//  certTypeId: this.paperId,
			//  certTypeName: this.paperFont,
			//  name: this.paperName,
			//  issuingAuthority: this.paperOrgan,
			//  beginDate: this.startDate + ' 00:00:00',
			//  endDate: this.endDate + ' 00:00:00',
			//  fileLogicalName: this.serverId
			// }
			// this.$http.post('/cldEdi/sysCert/addSysCert', obj).then((response) => {
			//  this.loading = false
			//  var data = response.body
			//  if (data.result) {
			//   this.isTips = false
			//   this.autoTips('新增成功')
			//   setTimeout(() => {
			//    this.$router.go(-1)
			//   }, self.sec)
			//  } else {
			//   this.autoTips(data.message)
			//   return
			//  }
			// }, (response) => {
			//  this.loading = false
			//  this.autoTips('服务中断，稍后请重试！')
			//  return
			// })
		}
	},
	watch: {
		paperId (newVal, oldVal) {
			var status = this.queryData.status
			if (status === 'edit') {
				if (oldVal !== newVal && oldVal !== '') {
					this.isTips = true
				}
			}
			if (status === 'add') {
				if (oldVal !== newVal) {
					this.isTips = true
				}
			}
		},
		paperName (newVal, oldVal) {
			var status = this.queryData.status
			if (status === 'edit') {
				if (oldVal !== newVal && oldVal !== '') {
					this.isTips = true
				}
			}
			if (status === 'add') {
				if (oldVal !== newVal) {
					this.isTips = true
				}
			}
		},
		paperOrgan (newVal, oldVal) {
			var status = this.queryData.status
			if (status === 'edit') {
				if (oldVal !== newVal && oldVal !== '') {
					this.isTips = true
				}
			}
			if (status === 'add') {
				if (oldVal !== newVal) {
					this.isTips = true
				}
			}
		},
		startDate (newVal, oldVal) {
			var status = this.queryData.status
			if (status === 'edit') {
				if (oldVal !== newVal && oldVal !== '') {
					this.isTips = true
				}
			}
			if (status === 'add') {
				if (oldVal !== newVal) {
					this.isTips = true
				}
			}
		},
		endDate (newVal, oldVal) {
			var status = this.queryData.status
			if (status === 'edit') {
				if (oldVal !== newVal && oldVal !== '') {
					this.isTips = true
				}
			}
			if (status === 'add') {
				if (oldVal !== newVal) {
					this.isTips = true
				}
			}
		},
		imgsrc (newVal, oldVal) {
			var status = this.queryData.status
			if (status === 'edit') {
				if (oldVal !== newVal && oldVal !== '') {
					this.isTips = true
				}
			}
			if (status === 'add') {
				if (oldVal !== newVal) {
					this.isTips = true
				}
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/pages/paper-detail/PaperDetail.js